<template>
  <div>
    <NavigationBar />
    <LockedSection />
    <!-- <Footer /> -->
  </div>
</template>

<script setup>
import NavigationBar from "@/components/Layout/NavigationBar.vue";
import LockedSection from "@/components/Layout/LockedSection.vue";
// import Footer from "@/components/Layout/Footer.vue";
</script>